export default __webpack_public_path__ + "static/media/dashboard-mobile.80e63a00.png";